import { tv } from 'tailwind-variants';

export const dividerStyle = tv({
  base: 'flex items-center',
  variants: {
    simple: {
      true: 'border-t border-solid',
      false: [
        "before:content-[''] before:h-[1px] before:flex-grow before:bg-stroke before:mr-4",
        "after:content-[''] after:h-[1px] after:flex-grow after:bg-stroke after:ml-4"
      ]
    },
    color: {
      light: 'border-white',
      dark: 'border-stroke'
    }
  },
  defaultVariants: {
    color: 'dark'
  }
});
